import { Route, Routes } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import AdminDashboard from "../../pages/admin/AdminDashboard";
import AdminProfile from "../../pages/admin/AdminProfile";
import Assistant from "../../pages/assistant/Assistant";
import ProgramEditor from "../../pages/programs/ProgramEditorRouter";
import PaginatedTransactions from "../../pages/payments/PaginatedTransactions";
import InvitationsManager from "../../components/users/InvitationManager";
import PaginatedReports from "../../pages/reports/PaginatedReports";
import ReportPage from "../../pages/reports/ReportPage";
import ReportEditor from "../../pages/reports/ReportEditor";
import PaginatedPrograms from "../../pages/programs/PaginatedPrograms";
import ProgramPage from "../../pages/programs/ProgramPage";
import RetestManagement from "../../pages/retests/RetestManagent";
import AdminCompanyPrograms from "../../pages/programs/AdminCompanyPrograms";
import RetestPage from "../../pages/retests/RetestPage";
import PentestReports from "../../pages/automated-report/PentestReports";
import PDFEditor from "../../pages/automated-report/PDFEditor";
import PaginatedUsers from "../../pages/users/PaginatedUsers";
import OrgSettingsPage from "../../pages/settings/OrgSettingsPage";
import ResearcherProfile from "../../pages/researcher/Profile";
import CompanyManagement from "../../pages/companies/CompanyManagement";
import ChecklistTemplatesPage from "../../pages/admin/ChecklistTemplatesPage";
import ChecklistTemplateEditor from "../../pages/admin/ChecklistTemplateEditor";
import ProgramChecklistEditor from "../../pages/admin/ProgramChecklistEditor";
import ChecklistItemWorkspace from "../../pages/researcher/ChecklistItemWorkspace";
import ChecklistReviewQueue from "../../pages/admin/ChecklistReviewQueue";
import DelegationManagement from "../../pages/delegations/DelegationManagement";
import AutoDelegationMonitoring from "../../pages/admin/AutoDelegationMonitoring";
import AssetDetailPage from "../../pages/Assets/AssetDetailPage";
import AssetInventoryPage from "../../pages/Assets/AssetInventoryPage";
import CreateAssetPage from "../../pages/Assets/CreateAsset/CreateAssetPage";
import OnboardingDocumentationRoutes from "./OnboardingDocumentationRoutes";
import CommentsPage from "../../pages/admin/CommentsPage";
import NotificationsPage from "../../pages/notifications/NotificationsPage";
import OrganizationsSubscriptions from "../../pages/admin/OrganizationsSubscriptions";

const SubAdminRoutes = () => {
  return (
    <Routes>
      <Route index element={<AdminDashboard />} />

      <Route path="programs/:id/edit" element={<ProgramEditor />} />
      <Route path="/create-program" element={<ProgramEditor />} />
      <Route path="invitation" element={<InvitationsManager />} />

      <Route path="profile/*" element={<AdminProfile />} />
      <Route path="settings/*" element={<OrgSettingsPage />} />
      <Route path="reports" element={<PaginatedReports />} />
      <Route path="reports/:id" element={<ReportPage />} />
      <Route path="reports/:id/edit" element={<ReportEditor />} />

      <Route path="programs" element={<PaginatedPrograms />} />
      <Route path="companies" element={<AdminCompanyPrograms />} />
      <Route path="companies/:companyId" element={<AdminCompanyPrograms />} />
      <Route path="programs/:id" element={<ProgramPage />} />
      <Route path="programs/:programId/checklists/:checklistId" element={<ProgramChecklistEditor />} />
      <Route path="programs/:programId/runs/:runId/checklists/:checklistId" element={<ProgramChecklistEditor />} />

      <Route path="/retests" element={<RetestManagement />} />
      <Route path="/retests/:retest_id" element={<RetestPage />} />

      <Route path="users" element={<PaginatedUsers />} />
      <Route path="users/researcher-profile/:userId" element={<ResearcherProfile />} />

      <Route path="delegations" element={<DelegationManagement />} />
      <Route path="auto-delegation-monitor" element={<AutoDelegationMonitoring />} />
      <Route path="company-management" element={<CompanyManagement />} />

      
      <Route path="checklist-templates" element={<ChecklistTemplatesPage />} />
      <Route path="checklist-templates/create" element={<ChecklistTemplateEditor />} />
      <Route path="checklist-templates/:id/view" element={<ChecklistTemplateEditor />} />
      <Route path="checklist-templates/:id/edit" element={<ChecklistTemplateEditor />} />

      {/* Checklist Review Routes */}
      <Route path="checklist-review" element={<ChecklistReviewQueue />} />
      <Route path="checklist-review/items/:itemId" element={<ChecklistItemWorkspace />} />

      <Route path="assistant/*" element={<Assistant />} />

      <Route path="payments/*" element={<PaginatedTransactions />} />
      <Route path="pentest-reports" element={<PentestReports />} />
      <Route path="pentest-reports/:report_id/edit" element={<PDFEditor />} />
      <Route path="comments" element={<CommentsPage />} />
      <Route path="notifications" element={<NotificationsPage />} />

      <Route path="companies/:companyId/assets/create" element={<CreateAssetPage />} />
      <Route path="companies/:companyId/assets/create/:id" element={<CreateAssetPage />} />
      <Route path="companies/:companyId/assets/:id" element={<AssetDetailPage />} />
      <Route path="assets" element={<AssetInventoryPage />} />
      <Route path="assets/:id" element={<AssetDetailPage />} />
      <Route path="assets/create" element={<CreateAssetPage />} />
      <Route path="assets/create/:id" element={<CreateAssetPage />} />
      <Route path="onboarding-documentation/*" element={<OnboardingDocumentationRoutes />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
};

export default SubAdminRoutes;
